import './PreventiveReportCreateFooter.scss';

import { useSurveyCreateForm } from "../../../../../hooks/useSurveyCreateForm";

import { Button } from "../../../../../common-components/Buttons/Buttons";

const PreventiveReportCreateFooter = () => {
    const { handleSend } = useSurveyCreateForm();

    return (
        <div className={"preventive-report-create-footer"}>
            <Button title={"Добавить"} onClick={handleSend}/>
        </div>
    )
}

export default PreventiveReportCreateFooter;